import { render, staticRenderFns } from "./review-video.vue?vue&type=template&id=2bfb152a"
import script from "./review-video.vue?vue&type=script&lang=ts"
export * from "./review-video.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports